import router from '@/providers/router/'
import Vue from 'vue';

function getPath(state, resource) {
    if(state[resource] && !!Object.getOwnPropertyDescriptor(state[resource], 'path')) {
        return state[resource].path(router.currentRoute.params);
    }
    return resource;
}

export const baseActions = {
    all({commit, state}, { resource, queryParameters, cacheResult }) {
        cacheResult = cacheResult != null ? cacheResult : true;

        return new Promise((resolve) => { 
            var path = getPath(state, resource);
            //Get all
            state.api.all(path, queryParameters)
            .then((response) => {
                if(cacheResult){ 
                    commit('all',
                    {
                        resource: resource,
                        result: response.data.result 
                    });
                }
                resolve(response.data);
            }).catch((error) => {
                this.dispatch('errors/setErrors', error);
            });
        });
    },
    search({state}, query) {
        return new Promise((resolve) => { 
            state.api.search(query)
            .then((response) => {
                resolve(response.data.result);
            })
            .catch((error) => {
                this.dispatch('errors/setErrors', error);
            });
        });
    },
    find({commit, state}, {resource, id, cacheResult}) {
        cacheResult = cacheResult != null ? cacheResult : true;

        return new Promise((resolve) => {
            //caching solution
            var requestedId = id;

            var filter = state[resource].items.filter(({id}) => id == requestedId);
            //check if item is already in store
            if(filter.length > 0  && cacheResult) {
                commit('find', {
                    resource: resource,
                    result: filter[0]
                });
                resolve(filter[0]);
            }
            else {
                //get new item from server
                var path = getPath(state,resource);
                //Find
                state.api.find(path,requestedId)
                .then((response) => {
                    commit('find',
                    { 
                        resource: resource,
                        result: response.data.result 
                    });
                    resolve(response.data.result);
                }).catch((error) => {
                    this.dispatch('errors/setErrors', error);
                });
            }
        });
    },
    create({commit, state}, {resource, params}) {
        let loader = Vue.$loading.show();
        return new Promise((resolve) => {
            var path = getPath(state,resource);
            state.api.create(path,params)
            .then((response) => {
                commit('add',
                { 
                    resource: resource,
                    result: response.data.result 
                });
                loader.hide();
                this.dispatch('errors/clearErrors');
                resolve(response.data.result);
            })
            .catch((error) => {
                loader.hide();
                this.dispatch('errors/setErrors', error);
            });
        })
    },
    update({commit,state}, {resource, params}) {
        return new Promise((resolve) => {
            var path = getPath(state,resource);
            state.api.update(path,params)
            .then((response) => {   
                commit('update',
                { 
                    resource: resource,
                    result: response.data.result 
                });
                this.dispatch('errors/clearErrors');
                resolve(response.data.result);
            })
            .catch((error) => {
                this.dispatch('errors/setErrors', error);
            });
        });
    },
    delete({commit,state},{ resource, id }) {
        return new Promise((resolve) => {
            var path = getPath(state,resource);
            state.api.delete(path, id)
            .then(() => {
                commit('delete', {
                    resource: resource,
                    id: id
                });
                resolve(id);
            })
            .catch((error)=> {
                this.dispatch('errors/setErrors', error);
            });
        });
    },
    execute({state}, {resource, id, action, params}) {
        return new Promise((resolve) => {
            var path = getPath(state, resource);
            state.api.execute(path, id, action, params)
            .then((response) => {              
                resolve(response.data.result);
            })
            .catch((error) => {
                this.dispatch('errors/setErrors', error);
            });
        });
    },
    executeCommand({ state }, { resource, params }) {
        return new Promise((resolve) => {
            var path = getPath(state, resource);
            state.api.excuteCommand(path, params)
                .then((response) => {
                    resolve(response.data.result);
                })
                .catch((error) => {
                    this.dispatch('errors/setErrors', error);
                });
        });
    },
    getImage({ state }, { resource,filename}) {
        return new Promise((resolve) => {
            var path = getPath(state, resource);
            state.api.getImage(path, filename)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    this.dispatch('errors/setErrors', error);
                });
        });
    },
    downloadFile(state, resource, name) {
        return new Promise((resolve,reject) => {
            state.api.download(resource)
            .then((response) => {
                // It is necessary to create a new blob object with mime-type explicitly set
                // otherwise only Chrome works like it should
                var blob = response.data;

                // IE doesn't allow using a blob object directly as link href
                // instead it is necessary to use msSaveOrOpenBlob
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                } 

                // For other browsers: 
                // Create a link pointing to the ObjectURL containing the blob.
                const data = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = data;
                link.download= name;
                document.body.appendChild(link);
                link.click();
                setTimeout(function(){
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(data);
                }, 100)
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}